window.HarriUpskillIntegrationAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);
    const UpskillUrl = publicConfiguration.HARRI_UPSKILL_INTEGRATION;

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsCoreServersBaseURL : publicConfiguration.APIServerBaseURL);

    self.getBrandOptions = function (brandId) {
        let deferred = $q.defer();

        _protected.request(UpskillUrl + `upskill/brands/${brandId}/options`, 'GET')
            .then((res) => {
                deferred.resolve(res.data.data);
            }).catch((err) => {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUpskillLaunchLink = function (brand_id, params = {lang: 'en'}) {
        let deferred = $q.defer();
        _protected.request(UpskillUrl + `upskill/brands/${brand_id}/launch`, 'GET', params)
            .then((res) => {
                deferred.resolve(res?.data?.data?.redirection_link);
            }).catch((err) => {
            deferred.reject(err);
        });

        return deferred.promise;
    }

};

window.HARRI_UPSKILL_INTEGRATION_ERROR_CODES = {
    INSUFFICIENT_CREDENTIALS: 'INSUFFICIENT_CREDENTIALS',
};